<template>
  <app-header-menu v-if="route.meta.layout && route.meta.layout !== 'auth'" />
  <div
    class="container p-4 mx-0 min-w-full fixed"
    style="top: 130px; height: calc(100% - 130px);
    overflow-y: scroll;"
  >
    <router-view />
  </div>
  <teleport to="body">
    <AppLoader v-if="showLoader" />
    <AppError v-if="showError" />
  </teleport>
</template>

<script>
import { getCurrentInstance } from 'vue'
import AppHeaderMenu from '@/components/layout/app/AppHeaderMenu'
import AppLoader from '@/components/ui/AppLoader'
import { useLoader } from '@/services/useLoader'
import AppError from '@/components/ui/AppError'
import { useRoute, useRouter } from 'vue-router'
import { useError } from '@/services/useError'

export default {
  components: { AppHeaderMenu, AppLoader, AppError },

  setup() {
    const router = useRouter()
    const route = useRoute()
    const app = getCurrentInstance()
    const dayjs = app.appContext.config.globalProperties.dayjs
    return { ...useLoader(), ...useError(), router, route, dayjs }
  },
}
</script>

<style lang="scss">
body {
  font-family: 'Noto Sans JP', sans-serif !important;
}
tr {
  height: 40px;
}
</style>

<style lang="scss">
@import './scss/tabs.scss';
@import './scss/icons.scss';
@import './scss/form.scss';

.border-fix {
  width: 24px;
  margin-right: -24px;
}

.status-btn {
  width: 160px;
  height: 40px;
}

html,
body {
  height: 100%;
}
</style>
